/**
 * EmptyState.tsx — Carbon Empty States-pattern
 * (patterns/empty-states-pattern)
 *
 * Replikert i native CSS Modules med --cds-* tokens.
 *
 * Carbon-standard som følges:
 * - Pictogram (produktiv, 48px min) sentrert
 * - Kort tittel (heading-02) + én setning beskrivelse (body-01)
 * - Valgfri handling (primary button)
 * - Sentrert layout, generøs padding
 *
 * Bruk:
 *   <EmptyState
 *     pictogramName="NoData"
 *     title="Ingen jobber funnet"
 *     description="Opprett din første jobb for å komme i gang."
 *     actionLabel="Opprett jobb"
 *     onAction={openCreateModal}
 *   />
 */

import styles from './empty-state.module.css';
import * as Pictograms from '@carbon/pictograms-react';

interface EmptyStateProps {
  /** Navn på Carbon-pictogram (eksport fra @carbon/pictograms-react) */
  pictogramName: string;
  /** Kort tittel */
  title: string;
  /** Én setning beskrivelse */
  description?: string;
  /** Valgfri handlingsknapp-tekst */
  actionLabel?: string;
  /** Handler for handlingsknappen */
  onAction?: () => void;
}

export default function EmptyState({
  pictogramName,
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  // Slå opp pictogram dynamisk — ukjent navn → ingen pictogram (tittel står igjen)
  const Pictogram = (Pictograms as Record<string, React.ComponentType<{ size?: number }>>)[
    pictogramName
  ];

  return (
    <div className={styles.emptyState}>
      {Pictogram && (
        <div className={styles.pictogramWrapper}>
          <Pictogram size={48} />
        </div>
      )}
      <h2 className={styles.title}>{title}</h2>
      {description && <p className={styles.description}>{description}</p>}
      {actionLabel && onAction && (
        <button type="button" className={styles.action} onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
